import { useDesignSystem } from 'contexts/design-system'
import GroupedComboBoxEui from './groupedComboBox.eui'
import GroupedComboBoxMui from './groupedComboBox.mui'
import { GroupedComboBoxProps } from 'components/ComboBox/types'

export type { GenericWithOptions, GroupedComboBoxProps, OptionsGroup } from 'components/ComboBox/types'
export { DEFAULT_DEBOUNCE_DELAY_MS } from 'components/ComboBox/useComboBoxState'

/**
 * Shared combo box that renders its options in groups. Renders the EUI or MUI
 * presentation based on the host form's design system (`DesignSystemProvider`,
 * default `'eui'`) at identical prop parity.
 */
export default function GroupedComboBox<T>( props: GroupedComboBoxProps<T> ) {
	return useDesignSystem() === 'mui'
		? <GroupedComboBoxMui {...props} />
		: <GroupedComboBoxEui {...props} />
}
